module.exports = __webpack_public_path__ + "img/feedback_large.e4f8a88f.png";